import { useEffect, useRef } from 'react';
import { paymentSchedule } from '@/mocks/homeData';

export default function PricingSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in-up');
            entry.target.classList.remove('opacity-0');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="pricing" ref={sectionRef} className="relative w-full py-20 md:py-32 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="reveal opacity-0 inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-widest text-foreground-600 border border-foreground-300 rounded-full uppercase">
            Pricing &amp; Payment
          </span>
          <h2 className="reveal opacity-0 font-heading text-4xl md:text-5xl font-semibold text-foreground-900 mb-4 text-balance">
            분양가 및 납부 안내
          </h2>
          <p className="reveal opacity-0 text-foreground-600 text-lg md:text-xl max-w-2xl mx-auto">
            HUG 전세자금대출 80% 지원으로 계약금 10%만으로 입주 가능합니다
          </p>
        </div>

        {/* Payment Schedule */}
        <div className="reveal opacity-0">
          <h3 className="text-xl font-semibold text-foreground-900 mb-6 text-center">납부 일정</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {paymentSchedule.map((item, i) => (
              <div key={item.step} className="relative p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/50 text-center">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-100 text-primary-600 text-base font-bold">
                  {i + 1}
                </div>
                <h4 className="text-base font-semibold text-foreground-900 mb-1">{item.step}</h4>
                <p className="text-sm text-foreground-500 mb-1">{item.timing}</p>
                <p className="text-sm text-primary-600 font-medium">{item.note}</p>
                {i < paymentSchedule.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-px bg-background-300" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}